import { AccountsApiService } from '@accounts/domain';
import { RecaptchaRequest } from '@accredible-frontend-v2/recaptcha';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ForgotPasswordApiService extends AccountsApiService {
  forgotPassword(email: string, recaptcha: string, v3Recaptcha: boolean): Observable<any> {
    // TODO: Should be a POST and use body instead of parameters
    return this._get(
      `/v1/accounts/auth/send_password_reset_email?email=${encodeURIComponent(email)}&${
        v3Recaptcha ? RecaptchaRequest.V3 : RecaptchaRequest.V2
      }=${recaptcha}`,
    ).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
